export enum Frameworks {
  esrs = 'ESRS',
  vsme = 'VSME',
  ifrs = 'IFRS',
  tcfd = 'TCFD',
  'esrs-oil-and-gas' = 'ESRS Oil and Gas',
  'entity-specific' = 'Entity-specific',
  sasb = 'SASB',
}

export enum FrameworkRefs {
  esrs = 'esrs',
  vsme = 'vsme',
  ifrs = 'ifrs',
  tcfd = 'tcfd',
  'esrs-oil-and-gas' = 'esrs-oil-and-gas',
  'entity-specific' = 'entity-specific',
  sasb = 'sasb',
}

export const FrameworkOptions = [
  { label: Frameworks.esrs, value: FrameworkRefs.esrs },
  { label: Frameworks.vsme, value: FrameworkRefs.vsme },
  { label: Frameworks.ifrs, value: FrameworkRefs.ifrs },
  { label: Frameworks.tcfd, value: FrameworkRefs.tcfd },
  { label: Frameworks['esrs-oil-and-gas'], value: FrameworkRefs['esrs-oil-and-gas'] },
  { label: Frameworks['entity-specific'], value: FrameworkRefs['entity-specific'] },
  { label: Frameworks.sasb, value: FrameworkRefs.sasb },
];
